import { FanChevronDownIcon } from './FanChevronDownIcon';

/**
 * author: GreenTurtwig
 * id 33DAA830-9E16-4AF0-A1B8-F44EA4EF9787
 * name fan-chevron-down
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fan-chevron-down.svg
 * tags
 * - Home Automation 
 */
export const FanSpeedDownIcon = FanChevronDownIcon;
export default FanSpeedDownIcon